// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mZUj","badges":"styles_badges__2ky2O"};